<template>
  <div>
    <cms-alert-modal-separate
      v-if="!hideAlerts.modal && containsModalAlerts"
      :globals="globals"
      :modal-array="modalAlerts"
      @close="closeAlert"
    />
    <cms-alert-banner-separate
      v-if="!hideAlerts.banner && containsBannerAlerts"
      :globals="globals"
      :banner-array="sortOpenAlertsByFeatured(openBannerAlerts)"
      @close="closeAlert"
    />
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';

defineOptions({ name: 'SeparateAlert' });

const props = defineProps({
  activeAlerts: {
    type: Array,
    default: () => [],
  },
  hideAlerts: {
    type: Object,
    default: () => ({}),
  },
});

const emit = defineEmits(['close']);

const store = useStore();

const globals = computed(() => store.state.globals);

const closedAlertsFromSessionStorage = computed(() => {
  if (!import.meta.client) return {};
  try {
    const raw = window.sessionStorage.getItem('thrillshare_alert_banner');
    return raw ? JSON.parse(raw) : {};
  } catch {
    return {};
  }
});

function getFirstAvailableModalAlertByType({ featured }) {
  return props.activeAlerts.find(
    (alert) =>
      !closedAlertsFromSessionStorage.value[alert.id] && alert.style === 'light_box' && alert.featured === featured,
  );
}

const modalAlerts = computed(() => {
  const globalModalAlert = getFirstAvailableModalAlertByType({ featured: true });
  const localModalAlert = getFirstAvailableModalAlertByType({ featured: false });
  return [globalModalAlert, localModalAlert].filter((alert) => Boolean(alert));
});

const bannerAlerts = computed(() => props.activeAlerts.filter((alert) => alert.style === 'banner'));

const containsModalAlerts = computed(() => modalAlerts.value.length > 0);

const containsBannerAlerts = computed(() => bannerAlerts.value.length > 0);

const openBannerAlerts = computed(() => {
  if (!containsBannerAlerts.value || !import.meta.client) return [];

  return bannerAlerts.value.filter((alert) => !closedAlertsFromSessionStorage.value[alert.id]);
});

function sortOpenAlertsByFeatured(openAlerts) {
  if (!openAlerts.length) return [];
  return openAlerts.slice().sort((a, b) => b.featured - a.featured);
}

/**
 * @param {*} closeObject { alertId: 1, closedByKeyboard: false }
 * Emits the close event to the parent component
 * to close the alert modal or banner
 */
function closeAlert(closeObject) {
  emit('close', closeObject);
}
</script>
